import React, { useEffect } from 'react';
import RetailLayout from 'containers/retail/layouts/RetailLayout';
import CardBox from 'components/common/structures/CardBox';
import ResidentialCustomerInformationForm from 'containers/retail/forms/residential/ResidentialCustomerInformationForm';
import { NextPage } from 'next';
import { observer } from 'mobx-react-lite';
import retailStores from 'stores/retail';
import { useRouter } from 'next/router';
import { RETAIL_RESIDENTIAL_UTILITY_ACCOUNT_INFORMATION_ROUTE } from 'config/retail/residential/routes';
import { triggerRetailBeginCheckoutEvent } from 'config/seo/events';
import {createGetServerSideProps} from "evcharging/app";
import {I18nPage} from "i18n/types/pages.enum";
import useI18n from "evcharging/hooks/useI18n";

const ResidentialCustomerInformation: NextPage = observer(() => {
  const { residentialCustomerInformationStore } = retailStores;
  const { onSubmit, restoreFromSession } = residentialCustomerInformationStore;
  const { push } = useRouter();
  const onCompleteStep = () =>
    onSubmit(() => push(RETAIL_RESIDENTIAL_UTILITY_ACCOUNT_INFORMATION_ROUTE));

  useEffect(() => {
    triggerRetailBeginCheckoutEvent();
  }, []);

  useEffect(restoreFromSession);

  const { t } = useI18n();

  return (
    <RetailLayout activeStep={1} onCompleteStep={onCompleteStep} isResidential>
      <CardBox title={t('retail.customer-info')}>
        <ResidentialCustomerInformationForm />
      </CardBox>
    </RetailLayout>
  );
});

export const getServerSideProps = createGetServerSideProps(
  undefined,
  undefined,
  [I18nPage.RetailCommon, I18nPage.RetailCustomerInformation]
);

export default ResidentialCustomerInformation;
